import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AngularEditorConfig, AngularEditorModule } from '@kolkov/angular-editor';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { IssueTrackerIncidenceDataPostDTO } from '../../../models/issue-tracker-incidence-data-dto';
import { IssueTrackerIncidenceDTO } from '../../../models/issue-tracker-incidence-dto';
import { Helpers } from '../../../helpers/helpers';
import { IssueTrackerIncidenceService } from '../../../services/issue-tracker-incidence.service';
import { ToastrService } from 'ngx-toastr';
import { IncidenceTemplateListComponent } from '../incidence-template-list/incidence-template-list.component';

@Component({
  selector: 'app-incidence-add-message',
  templateUrl: './incidence-add-message.component.html',
  styleUrls: ['./incidence-add-message.component.scss'],
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    AngularEditorModule,
    NgxDropzoneModule]
})
export class IncidenceAddMessageComponent implements OnChanges {

  @Input() idIncidence: string;
  @Input() isAdmin: boolean = false;
  @Input() incidence: IssueTrackerIncidenceDTO | null = null;
  @Output() onMessageSent = new EventEmitter<void>();
  @Output() onItResponseSaved = new EventEmitter<void>();

  newMessage: string = '';
  isInternal: boolean = false;
  sendingMessage: boolean = false;
  fileAttachedFiles: File[] = [];

  itResponseDraft: string = '';
  savingItResponse: boolean = false;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '180px',
    minHeight: '0',
    maxHeight: '180px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Introduzca el mensaje aquí...',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'strikeThrough',
        'subscript',
        'superscript',
        'heading',
        'fontName',
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode',
        'insertOrderedList',
        'justifyFull'
      ]
    ]
  };

  constructor(private helper: Helpers,
    private service: IssueTrackerIncidenceService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['incidence']) {
      this.itResponseDraft = this.incidence?.ItResponse ?? '';
    }
  }

  saveItResponse(): void {
    if (this.savingItResponse || !this.idIncidence) {
      return;
    }

    this.savingItResponse = true;

    this.service.updateItResponse(this.idIncidence, this.itResponseDraft).subscribe({
      next: () => {
        this.savingItResponse = false;
        this.toastr.success('La respuesta IT se ha guardado correctamente');
        this.onItResponseSaved.emit();
      },
      error: (err) => {
        this.savingItResponse = false;
        this.toastr.error('Error al guardar la respuesta IT');
      }
    });
  }

  onFileAttachedSelect(event: any) {
    if (this.fileAttachedFiles.length > 0) {
      this.fileAttachedFiles.splice(0, 1);
    }
    this.fileAttachedFiles.push(...event.addedFiles);
  }

  onFileAttachedRemove(event: any) {
    this.fileAttachedFiles.splice(this.fileAttachedFiles.indexOf(event), 1);
  }

  sendMessage() {
    if (!this.newMessage || this.newMessage.trim() === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Mensaje vacío',
        text: 'Por favor, escriba un mensaje antes de enviar'
      });
      return;
    }

    if (this.sendingMessage) {
      return;
    }

    this.sendingMessage = true;

    let postModel: IssueTrackerIncidenceDataPostDTO = new IssueTrackerIncidenceDataPostDTO();
    postModel.IdIncidence = this.idIncidence;
    postModel.Message = this.newMessage.trim();
    postModel.IsInternal = this.isInternal;

    if (this.fileAttachedFiles.length > 0)
      postModel.FileAttachedFile = this.fileAttachedFiles[0];

    var data = this.helper.getFormData(postModel);

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...'
    });
    Swal.showLoading();

    this.postData(data);

  }

  postData(data: FormData) {

    let observable = this.isAdmin ? this.service.addMessage(data) : this.service.addMessageUser(data);

    observable.subscribe(resp => {
      this.newMessage = '';
      this.isInternal = false;
      this.sendingMessage = false;
      this.fileAttachedFiles = [];
      this.onMessageSent.emit();
      this.toastr.success("El mensaje se ha enviado correctamente");
      Swal.close();
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al enviar el mensaje',
        text: 'Ocurrió un error'
      });
    });
  }

  fixAddMessageToBottom() {
    const addMessageElement = document.getElementById('add-message');
    const bodyElement = document.getElementById('issue-tracker-main-container');
    if (addMessageElement.classList.contains('fixed-bottom-message')) {
      addMessageElement.classList.add('hidding-bottom-message');
      setTimeout(() => {
        addMessageElement.classList.remove('hidding-bottom-message');
        addMessageElement.classList.remove('fixed-bottom-message');
        bodyElement.classList.remove('add-message-shown');
        bodyElement.style.marginBottom = '0';
        console.log('bodyElement remove', bodyElement.classList);
      }, 300);
    } else {
      addMessageElement.classList.add('fixed-bottom-message');
      bodyElement.classList.add('add-message-shown');
      bodyElement.style.marginBottom = addMessageElement.offsetHeight + 64 + 'px';
      console.log('bodyElement add', bodyElement.classList);
    }
  }

  openTemplateModal(): void {
    const modalRef = this.modalService.open(IncidenceTemplateListComponent, {
      ariaLabelledBy: 'modal-template-title',
      size: 'xl',
      centered: true
    });
    modalRef.componentInstance.idIncidence = this.idIncidence;

    modalRef.componentInstance.onTemplateSelected.subscribe((content: string) => {
      this.newMessage = content;
      modalRef.close();
    });
  }

}
